import React from 'react';
import clsx from 'clsx';

import { Helmet } from 'react-helmet-async';
import PropTypes from 'prop-types';
// import { useLocation } from 'react-router-dom';
import { makeStyles } from '@material-ui/styles';
import UserAlert from 'components/Alerts/UserAlert';

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
    width: '100%',
    height: '100%',
    minHeight: '100%',
    flex: 1,
  },
  container: {
    display: 'flex',
    height: 'calc(100% - 32px)',
  },
  actions: {
    navBar: {
      zIndex: 1,
      width: 350,
      minWidth: 350,
      flex: '0 0 auto',
      height: 'calc(100vh - 64)',
    },
  },
  children: {
    width: '100%',
  },
}));

const Page = (props) => {
  const { pageActions, title, children, className } = props;
  const classes = useStyles();

  // const location = useLocation();

  return (
    <div className={clsx(classes.root, className)}>
      {title && (
        <Helmet>
          <title>{title}</title>
        </Helmet>
      )}
      <div className={classes.container}>
        {pageActions && <div className={classes.actions}>{pageActions}</div>}
        <div className={classes.children}>{children}</div>
        <UserAlert />
      </div>
    </div>
  );
};

Page.propTypes = {
  pageActions: PropTypes.node,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  title: PropTypes.string,
};

Page.defaultProps = {
  pageActions: undefined,
  className: undefined,
  title: undefined,
};

export default Page;
